import { UrlHelper } from '@/common/helper/url-helper-service'
import { HttpHelper } from '@/common/helper/http-helper-service'
import { getServiceProviderUrls } from '@/common/constant/constants';

// `region` is passed into every call so the URL is resolved against the region currently
// selected in the signup form (it can change via dropdown mid-session). See getServiceProviderUrls.
export default class ServiceProviderServices {
    constructor() {
    }
    static saveServiceProvider = (params: object, region: number) => {
        const url = UrlHelper.getUrl(getServiceProviderUrls(region).createServiceProvider);
        return HttpHelper.postData(url, params);
    }
    static validatePhoneNumerAndSignup = (params: object, region: number) => {
        const url = UrlHelper.getUrl(getServiceProviderUrls(region).validatePhoneNumberAndSignup);
        return HttpHelper.postData(url, params);
    }

    static validateServiceProvider = (params: object, region: number) => {
        const url = UrlHelper.getUrl(getServiceProviderUrls(region).validateserviceprovider);
        return HttpHelper.postData(url, params);
    }

    static sendOTP = (params: object, region: number) => {
        const url = UrlHelper.getUrl(getServiceProviderUrls(region).sendotp);
        return HttpHelper.postData(url, params);
    }

    static verifyOTP = (params: object, region: number) => {
        const url = UrlHelper.getUrl(getServiceProviderUrls(region).verifyotp);
        return HttpHelper.postData(url, params);
    }

    static getServieproviderTimeZoneList = (region?: number) => {
        return HttpHelper.getData(getServiceProviderUrls(region).getTimeZoneAzureFunction);
    }
}
